import pages from '../namespaces/pages/fr';
import components from '../namespaces/components/fr';
import common from '../namespaces/common/fr';
import errors from '../namespaces/errors/fr';
import validation from '../namespaces/validation/fr';
import gameDetail from '../namespaces/gameDetail/fr';

export default {
  common,
  pages,
  components,
  errors,
  validation,
  gameDetail
}; 